var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var stdin_exports = {};
__export(stdin_exports, {
  default: () => mergeDataSchema
});
module.exports = __toCommonJS(stdin_exports);
var import_isNonNullable = require("./isNonNullable");
var import_mergeArray = __toESM(require("./mergeArray"));
const mergeObject = (a, b) => Object.assign(Object.assign({}, a), b);
const mergeStrategies = {
  type: (a, b) => b.type === "any" ? a.type : b.type,
  fields: (a, b) => a.type !== "object" ? void 0 : (0, import_mergeArray.default)(a.fields, b.fields, "id", mergeDataSchema),
  additionalFields: (a, b) => a.type !== "object" ? void 0 : mergeDataSchema(a.additionalFields, b.additionalFields),
  items: (a, b) => a.type !== "array" ? void 0 : mergeDataSchema(a.items, b.items),
  ui: (a, b) => mergeObject(a.ui, b.ui),
  validation: (a, b) => mergeObject(a.validation, b.validation),
  methods: (a, b) => (0, import_mergeArray.default)(a.methods, b.methods, "id"),
  enum: (a, b) => (0, import_mergeArray.default)(a.enum, b.enum, "value"),
  groups: (a, b) => (0, import_mergeArray.default)(a.groups, b.groups, "id", mergeObject),
  definitions: (a, b) => (0, import_mergeArray.default)(a.definitions, b.definitions, "id", mergeDataSchema),
  examples: (a, b) => [...a.examples, ...b.examples]
};
function mergeDataSchema(a, b) {
  if (!a && !b)
    return null;
  const ans = Object.assign({}, a);
  if (b) {
    Object.keys(b).forEach((k) => {
      if ((0, import_isNonNullable.isUndefined)(b[k])) {
        return;
      }
      if ((0, import_isNonNullable.isUndefined)(ans[k])) {
        ans[k] = b[k];
        return;
      }
      const mergeFn = mergeStrategies[k] || (() => b[k]);
      ans[k] = mergeFn(ans, b, k);
    });
  }
  return ans;
}
